import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  column: {
    backgroundColor: theme.palette.white.efesBackgroundLight,
    cursor: 'pointer',
    marginBottom: 20,
    borderRadius: 9,
    borderLeft: `1px solid ${theme.palette.gray.efesGray} `,
    borderRight: `1px solid ${theme.palette.gray.efesGray} `,
    borderBottom: `1px solid ${theme.palette.gray.efesGray} `,
  },
  disabled: {
    borderColor: 'transparent',
  },
  row: {
    width: '100%',
    padding: 8,
    paddingRight: theme.spacing(2),
    display: 'flex',
    alignItemsc: 'center',
    verticalAlign: 'middle',
  },
  headerRow: {
    paddingTop: 12,
    paddingBottom: 12,
    paddingLeft: 4,
    paddingRight: theme.spacing(1),
    float: 'left',
    display: 'flex',
    alignItemsc: 'center',
    verticalAlign: 'middle',
  },
  key: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  title: {
    fontSize: 16,
    [theme.breakpoints.down(375)]: {
      fontSize: 14,
    },
  },
  value: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
}));

export default useStyles;
